import React, {useState} from 'react';
import '../../assets/css/index.css';
import {Link} from 'react-router-dom';
import mojavez from '../../assets/images/mojavez-faaliyat.jpg';
import logo from '../../assets/images/redesigned.png';
import webvid from "../../assets/images/webm.webm";

const fontStyle = `@font-face {
    font-family: "font";
    src: url("../../assets/fonts/IRANSansWeb.woff") format("woff");
    font-weight: normal;
    font-style: normal;
}`

function AboutUsPage() {
    const [loading, setLoading] = useState(false);
    const [zoomed, setZoomed] = useState(false)
    return (
        <>
        <style>{fontStyle}</style>
        <div className='position-fixed w-100' style={{zIndex: 999,}}>
            {/* دکمه ورود کاربران - گوشه بالا چپ */}
            <Link
                to={'/login/'}
                className='btn btn-primary fs-6 fw-bold px-4 py-2'
                style={{position: 'absolute', top: 16, left: 16}}
            >ورود کاربران</Link>

            <div className='nav d-flex justify-content-around align-items-center mx-auto'
                style={{height: 150}}>
                <div className='d-flex'>
                    <img src={logo} style={{maxHeight: 150}} alt="FARVAHAR"
                        className='farvahar-img mx-auto'/>
                </div>
                <div className='d-flex flex-row justify-content-around align-items-center w-50'>
                    <Link to={'/'} className='fs-5 fw-bold py-3'>صفحه اصلی</Link>
                    {/* <div className='nav-1'>
                        <p className='fs-5 fw-bold mb-0  py-3'>محصولات</p>
                        <div className="mega-menu-1 mega-menu px-4 py-4 flex-column">
                            <Link
                                to={'/invoice'}
                                className="mx-auto"
                                onClick={(e) => {
                                    const nav = document.querySelector('.nav-2');
                                    nav.style.pointerEvents = 'none';
                                    setTimeout(() => {
                                        nav.style.pointerEvents = 'auto';
                                    }, 500);
                                }}
                            >نرم افزار واسط سامانه مودیان نسخه آنلاین ( آرسین2 )</Link>
                        </div>
                    </div> */}
                    <Link to={'/about-us'} className='fs-5 fw-bold py-3'>درباره ما</Link>
                </div>
            </div>
        </div>
            <div className='w-100 header d-flex flex-column'
                 style={{height: '100vh', paddingTop: 200, backgroundImage: 'none'}}>
                <div className='h-100 mx-auto container my-1 d-flex'>
                    <div className='w-50 d-flex flex-column'>
                        <p className='fs-4 fw-bold mb-4 text-black'>پیام مدیر عامل</p>
                        <p className='mb-3 fs-5 mx-auto'>(ساختن ایران از تغییر در درون خودمان آغاز می شود)</p>
                        <p className='mb-0 lh-lg text-justify ' style={{
                            width: '600px',
                            margin: '0 auto',
                            textAlign: 'justify',
                            lineHeight: '2',
                            textJustify: 'inter-word',
                            direction: 'rtl',
                        }}>شرکت فراز اندیشه آرسین
                            ( سهامی خاص ) در تاریخ 1398/02/21 در شهر
                            مشهد تاسیس شد. هدف شرکت طراحی
                            و تولید نرم افزارهای حوزه مالی و اداری با استفاده از سالها تجربه موفق در این حوزه و بکارگیری
                            نیروی های متخصص در زمینه امور مالی ، اداری و برنامه نویسی است.
                            ما به دنبال ایجاد تحول در مدیریت مالی و اداری با استفاده از فناوری های نوین هستیم.
                            هدف ما ارائه راهکار هایی هوشمند، سریع و کارآمد است که به کسب و کارها و کاربران کمک کند
                            فرآیندهای مالی خود را به شکل بهینه تر و مطمئن تری مدیریت کنند.
                        </p>
                        <p className='lh-lg text-justify' style={{
                            width: '600px',
                            margin: '0 auto',
                            textAlign: 'justify',
                            lineHeight: '2',
                            textJustify: 'inter-word',
                            direction: 'rtl',
                        }}>
                            ما در حال توسعه یک اکوسیستم نرم افزاری جامع هستیم که ترکیبی از نوآوری و امنیت را ارائه می
                            دهد.
                            رویکرد ما بر بهبود کارایی، شفافیت و کاهش هزینه ها متمرکز است تا کاربران بتوانند با اطمینان ،
                            از این اکوسیستم استفاده کنند.
                            ما به آینده ای هوشمند و دیجیتال باور داریم و با تمرکز بر فناوری های پیشرفته، در مسیر رشد و
                            پیشرفت حرکت میکنیم.
                        </p>
                        <p style={{
                            width: '600px',
                            margin: '0 auto',
                            textAlign: 'justify',
                            lineHeight: '2',
                            textJustify: 'inter-word',
                            direction: 'rtl',
                        }}>
                            با ما همراه باشید و از آینده لذت ببرید...
                        </p>
                    </div>
                    <div className='w-50 d-flex position-relative'>
                        <video autoPlay muted loop playsInline
                               style={{width: '1100px', backgroundColor: 'transparent', right: -150, top: -35}}
                               className="position-absolute">
                            <source src={webvid} type="video/webm"/>
                        </video>
                    </div>
                </div>
                <div className='container my-3'>
                    <p className='fs-4 fw-bold mb-4'>مجوز ها</p>
                    <div className='d-flex'>
                        <div className=''>
                            <p>مجوز فعالیت</p>
                            <div className='d-flex'>
                                <img onClick={() => setZoomed(true)} src={mojavez} style={{maxHeight: 250}}
                                     className='farvahar-img mx-auto pointer'/>
                            </div>
                            {zoomed && (
                                <div
                                    onClick={() => setZoomed(false)}
                                    style={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        width: '100vw',
                                        height: '100vh',
                                        backgroundColor: 'rgba(0,0,0,0.7)',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        zIndex: 1000,
                                        cursor: 'zoom-out',
                                    }}
                                >
                                    <img
                                        src={mojavez}
                                        alt="مجوز بزرگ‌شده"
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                            borderRadius: '10px',
                                            boxShadow: '0 0 20px #000',
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='w-100 d-flex'>
                    <div className='footer mx-auto p-5'
                         style={{
                             display: 'grid',
                             gridTemplateColumns: 'repeat(3, 1fr)',
                             gap: '12px',
                         }}>
                        <div>
                            <p className='fw-bold'>آدرس شرکت: مشهد بلوار معلم نبش معلم 16 برج البان طبقه 5 واحد 1</p>
                            <p className='fw-bold'>تلفن : 05136144100</p>
                        </div>
                        <div className='d-flex'>
                            <a referrerPolicy='origin' target='_blank' className='pointer h-100 ' style={{width: 130}}
                               href='https://trustseal.enamad.ir/?id=607621&Code=3h1ZjCnvOcszqirg8oEJoYMbqbqHPsD7'><img
                                referrerPolicy='origin'
                                src='https://trustseal.enamad.ir/logo.aspx?id=607621&Code=3h1ZjCnvOcszqirg8oEJoYMbqbqHPsD7'
                                alt='' code='3h1ZjCnvOcszqirg8oEJoYMbqbqHPsD7'/></a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutUsPage;
